import script from "./DialogRestaurant.vue?vue&type=script&setup=true&lang=ts"
export * from "./DialogRestaurant.vue?vue&type=script&setup=true&lang=ts"

import "./DialogRestaurant.vue?vue&type=style&index=0&id=7c4c1c6c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c4c1c6c"]])

export default __exports__